module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, _vm._l((_vm.data.rows), function(row) {
    return _c('tr', _vm._l((row.fields), function(field) {
      return _c('td', [_c('APPROVAL_' + field.fieldType, {
        tag: "component",
        attrs: {
          "data": field,
          "footnotes": _vm.footnotes
        }
      })], 1)
    }), 0)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf6ac43e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/TABLE.vue
// module id = 717
// module chunks = 0